export default __webpack_public_path__ + "static/media/2022-12-15-twitter-community-guidelines.b4830223.md";